import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomInputComponent } from './custom-input.component';
import { ApplicationPipesModule } from 'src/app/pipe/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';




@NgModule({
  declarations: [
    CustomInputComponent,    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationPipesModule  ,
    MatTooltipModule,
    NgxMaskDirective
  ],
  exports:[CustomInputComponent],
  providers: [provideNgxMask()]
})
export class CustomInputModule { }
